// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2m0Dm","gfeWrapper":"CalendarEvent_gfeWrapper__2HLV_"};